
<div class="about mt-24 container">
    <div class="container grid grid-rows-3 center justify-center">
      <div class="justify-center text-center">
        <h1>Work</h1>
      </div>
      <div class=" header-title w-96 justify-center text-center">
            Over the course of the year, I spent a significant amount of time creating resources and tools for the community and many project for brands
      </div>

    </div>

    <div *ngIf="isLoading" class=" justify-center align-center center text-center">
      <app-spinnerdetial></app-spinnerdetial>
    </div>

    <div class="box-projects">
      <div class="grid lg:grid-cols-3 xl:grid-cols-4 sm:grid-cols-2 box-grid ">

        <div *ngIf="role == 'admin' && !isLoading" [routerLink]="['add-work']" class="cards-image pl-3 pr-3  w-56 bg-blue-500 rounded">
          <div class="grid ">
            <div class="image mt-3">
              <img src="../../../assets/nft/plusimage.png" width="200" height="200" alt="">
            </div>
            <div class="text-detail mt-3 text-white">
              <h4 style="font-size: 16px; font-weight: 700;">Add Experience</h4>
            </div>
          </div>
        </div>

        <!-- <div class="container mt-48 text-center" *ngIf="isLoading">
          <app-spinnerdetial></app-spinnerdetial>
        </div> -->
        <div *ngFor="let item of dataWork" class="cards-image mt-3 pl-3 pr-3  w-56 bg-slate-500 rounded">
          <div class="grid ">
            <div class="image mt-3">
              <img src="{{item.imageLink}}" width="200" height="200" alt="">
            </div>
            <div class="text-detail mt-3 text-white">
              <h4 style="font-size: 16px; font-weight: 700;">{{item.name}}</h4>
              <p style="font-size: 14px; font-weight: 400;">{{item.description}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
